'use client';

import { cn } from '@/app/utils';
import type { OfficialShowcaseSectionData } from '../../types';
import { MediaAsset } from '../MediaAsset';
import { PortableTextContent } from '../PortableTextContent';
import { SectionShell } from '../section-shared';

export function SplitLayout({
  activeIndex,
  activeTab,
  section,
  setActiveIndex,
  tabs,
}: {
  activeIndex: number;
  activeTab: OfficialShowcaseSectionData['tabs'][number];
  section: OfficialShowcaseSectionData;
  setActiveIndex: (index: number) => void;
  tabs: OfficialShowcaseSectionData['tabs'];
}) {
  return (
    <SectionShell>
      <div className="flex items-center gap-[72px] sm:flex-col sm:items-stretch sm:gap-10">
        <div className="w-[420px] shrink-0 sm:w-full">
          <h2 className="font-semibold text-[36px] text-white leading-[1.15] sm:text-[28px]">{section.title}</h2>
          <PortableTextContent className="mt-4 leading-[1.5]" value={section.description} />
          {section.button?.href && section.button?.label && (
            <a
              className="mt-8 inline-flex h-12 w-fit items-center justify-center rounded-full border-2 border-[#0086FF] bg-transparent px-8 font-medium text-[#0086FF] text-sm transition-colors hover:bg-[#0086FF]/10"
              href={section.button.href}
              rel={/^https?:\/\//.test(section.button.href) ? 'noreferrer' : undefined}
              target={/^https?:\/\//.test(section.button.href) ? '_blank' : undefined}
            >
              {section.button.label}
            </a>
          )}
        </div>

        <div className="relative min-w-0 flex-1 sm:w-full">
          <div className="mb-4 flex flex-wrap items-center justify-end gap-4 sm:justify-start">
            {tabs?.map((tab, index) => {
              const active = index === activeIndex;

              return (
                <button
                  key={tab._key || `${tab.tabLabel}-${index}`}
                  className={cn(
                    'flex h-10 items-center justify-center rounded-[10px] border px-4 text-center font-medium text-xs leading-3 transition-colors',
                    active
                      ? 'border-[#999999] text-white'
                      : 'border-[#444444] text-white/55 hover:border-[#666666] hover:text-white/80',
                  )}
                  onClick={() => setActiveIndex(index)}
                  type="button"
                >
                  {tab.tabLabel}
                </button>
              );
            })}
          </div>

          <div className="overflow-hidden rounded-2xl bg-white/8">
            <MediaAsset className="aspect-[4/3]" media={activeTab.media} />
          </div>
        </div>
      </div>
    </SectionShell>
  );
}
